import type SVGType from 'types/svg.types';

const MoreIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.05937 19.2256L6.40076 14.668C5.88225 13.7791 6.52341 12.6628 7.55246 12.6628H12.8697C13.8988 12.6628 14.5399 13.7791 14.0214 14.668L11.3628 19.2256C10.8483 20.1076 9.57388 20.1076 9.05937 19.2256Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <mask id="path-2-inside-1_4244_3648" fill="white">
      <rect
        x="17.7817"
        y="5.46606"
        width="8.85333"
        height="8.85333"
        rx="1.33333"
      />
    </mask>
    <rect
      x="17.7817"
      y="5.46606"
      width="8.85333"
      height="8.85333"
      rx="1.33333"
      stroke="currentColor"
      strokeWidth="4"
      mask="url(#path-2-inside-1_4244_3648)"
    />
    <circle
      cx="19.331"
      cy="22.1603"
      r="3.42667"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default MoreIcon;
